import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const LightBulbIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 1a7 7 0 0 0-7 7 5.7 5.7 0 0 0 1.8 4.2c.6.6 1 1.2 1.1 2a1 1 0 0 0 2-.4 5.6 5.6 0 0 0-1.7-3C7.2 9.8 7 8.8 7 8a5 5 0 1 1 10 0 3.6 3.6 0 0 1-1.2 2.8c-.9.9-1.5 1.8-1.7 3a1 1 0 1 0 2 .4c.1-.7.4-1.3 1-2A5.7 5.7 0 0 0 19 8a7 7 0 0 0-7-7ZM8 18c0-.6.4-1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 4c0-.6.4-1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z" />
    </Icon>
  )
);
export default LightBulbIcon;
